const getKeyByAttribute = (el, attr) => {
    if (attr === 'data-href') return el.dataset.href.substring(1);

    return el.getAttribute(attr);
};

const getKey = (el) => el.dataset.hoverKey;

class HeaderUnitsHoverMediator {
    constructor(attributes, rootElement) {
        let root = typeof rootElement === 'string' ? document.querySelector(rootElement) : rootElement;

        if (!root) root = document;

        const itemsConfig = typeof attributes === 'string'
            ? { attributes: [attributes], items: [...root.querySelectorAll(`[${attributes}]`)] }
            : attributes
                .map((attr) => ({ attr, items: [...root.querySelectorAll(`[${attr}]`)] }))
                .reduce((accumulator, item) => {
                    accumulator.attributes = accumulator.attributes.concat(new Array(item.items.length).fill(item.attr));
                    accumulator.items = accumulator.items.concat(item.items);

                    return accumulator;
                }, { attributes: [], items: [] });

        const map = new Map();

        itemsConfig.items.forEach((item, index) => {
            const attr = itemsConfig.attributes[index];
            const key = getKeyByAttribute(item, attr);
            let arr;

            if (map.has(key)) {
                arr = map.get(key);
            } else {
                arr = [];
                map.set(key, arr);
            }

            item.dataset.hoverKey = key;

            arr.push(item);
        });

        this._map = map;
        this._items = itemsConfig.items;
        this.hasStart = true;
    }

    start() {
        this._hoverHandler = (evt) => {
            this.hoverListener(evt);
        };
        this._outHandler = (evt) => {
            this.outListener(evt);
        };

        this._items.forEach((el) => {
            el.addEventListener('mouseover', this._hoverHandler);
            el.addEventListener('mouseout', this._outHandler);
        });
    }

    hoverListener(evt) {
        const target = evt.currentTarget || evt.target;
        const key = getKey(target);

        if (!this._map.has(key)) return;

        this._map.get(key).forEach((el) => {
            el.classList.add('hover');
        });
    }

    outListener(evt) {
        const target = evt.currentTarget || evt.target;
        const key = getKey(target);

        if (!this._map.has(key)) return;

        this._map.get(key).forEach((el) => {
            el.classList.remove('hover');
        });
    }
}

export default HeaderUnitsHoverMediator;
